import PropTypes from 'prop-types';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
import { PATH_AUTH } from '@/routes/paths';
import LoadingScreen from '@/components/loading-screen';
import { getDashboardHomePath } from '@/utils/dashboard';
import { resolveNextPath } from './nextPath';
import { useSessionContext } from './useSessionContext';

// ---------------------------------------------------------------------

GuestGuard.propTypes = {
  children: PropTypes.node,
};

export default function GuestGuard({ children }) {
  const { isAuthenticated, SSOLoginURL, isInitialized, user } = useSessionContext();
  const [searchParams] = useSearchParams();
  const location = useLocation();

  const localStorageNextParam = localStorage.getItem('next');
  const nextParam = searchParams.get('next') || localStorageNextParam;

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    if (location.pathname === '/auth/login' && SSOLoginURL) {
      window.location.href = SSOLoginURL;
    }
  } else {
    if (user?.registrationPending) {
      // Quem chega pelo site entra em `/auth/register/`. Redirecionar daí remonta a página no
      // meio do cadastro, e a página nova pede outro código de e-mail.
      if (location.pathname.replace(/\/+$/, '') === PATH_AUTH.register) {
        return <> {children} </>;
      }

      return <Navigate to={`${PATH_AUTH.register}?pending=email`} replace />;
    }

    return <Navigate to={resolveNextPath(nextParam) || getDashboardHomePath(user)} />;
  }

  return <> {children} </>;
}
